/**
 * NERO PRO · Simge seti
 *
 * Tek çizgi kalınlığı (1.6), tek geometri dili, aynı 24'lük kılavuz.
 * Harici simge kütüphanesi yok: hem hafif hem de yıllar içinde stil kaymaz.
 */

export type SimgeAdi =
  | 'ana-sayfa' | 'is-emri' | 'musteri' | 'arac' | 'kasa' | 'stok' | 'fiyat'
  | 'log' | 'post' | 'yonetici' | 'ayar' | 'ara' | 'arti' | 'carpi' | 'onay'
  | 'uyari' | 'ok-sag' | 'ok-sol' | 'ok-asagi' | 'cop' | 'kalem' | 'indir'
  | 'yukle' | 'dosya' | 'foto' | 'yenile' | 'cikis' | 'kilit' | 'yedek'
  | 'gecmis' | 'grafik' | 'telefon' | 'bilgi' | 'menu';

const YOLLAR: Record<SimgeAdi, string> = {
  'ana-sayfa': 'M3 10.2 12 3l9 7.2M5 9.4V20h14V9.4',
  'is-emri':   'M7 3h7l5 5v13H7zM14 3v5h5M10 13h6M10 17h4',
  'musteri':   'M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8M4.5 20.5a7.5 7.5 0 0 1 15 0',
  'arac':      'M4 16v3M20 16v3M3 16h18v-4l-1.8-4.6A2 2 0 0 0 17.3 6H6.7a2 2 0 0 0-1.9 1.4L3 12zM6.5 16v-1M17.5 16v-1',
  'kasa':      'M3 7h18v12H3zM3 11h18M7 15h3',
  'stok':      'M12 3 3 7.5v9L12 21l9-4.5v-9zM3 7.5 12 12m0 0 9-4.5M12 12v9',
  'fiyat':     'M3 12V5a2 2 0 0 1 2-2h7l9 9-9 9zM8 8.5h.01',
  'log':       'M3 18l4-7 4 4 4-8 6 11',
  'post':      'M4 4h16v16H4zM4 15l4.5-4.5 4 4L16 11l4 4M9 9h.01',
  'yonetici':  'M12 3l7 3v6c0 4.4-2.9 7.8-7 9-4.1-1.2-7-4.6-7-9V6zM9.5 12l1.8 1.8 3.4-3.6',
  'ayar':      'M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6M19.5 12a7.5 7.5 0 0 0-.1-1.2l2-1.5-2-3.5-2.4 1a7.5 7.5 0 0 0-2-1.2l-.4-2.6h-4l-.4 2.6a7.5 7.5 0 0 0-2 1.2l-2.4-1-2 3.5 2 1.5a7.6 7.6 0 0 0 0 2.4l-2 1.5 2 3.5 2.4-1a7.5 7.5 0 0 0 2 1.2l.4 2.6h4l.4-2.6a7.5 7.5 0 0 0 2-1.2l2.4 1 2-3.5-2-1.5c.07-.4.1-.8.1-1.2z',
  'ara':       'M10.5 17a6.5 6.5 0 1 0 0-13 6.5 6.5 0 0 0 0 13M20 20l-4.9-4.9',
  'arti':      'M12 5v14M5 12h14',
  'carpi':     'M6 6l12 12M18 6 6 18',
  'onay':      'M4.5 12.5 9 17l10.5-10.5',
  'uyari':     'M12 8.5v5M12 17h.01M10.3 3.9 2.5 17.4A2 2 0 0 0 4.2 20.4h15.6a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z',
  'ok-sag':    'M9 5l7 7-7 7',
  'ok-sol':    'M15 5l-7 7 7 7',
  'ok-asagi':  'M5 9l7 7 7-7',
  'cop':       'M4 7h16M9.5 7V4.5h5V7M6.5 7l1 13h9l1-13M10.5 11v5.5M13.5 11v5.5',
  'kalem':     'M4 20h4L19.5 8.5a2.1 2.1 0 0 0-3-3L5 17zM15 6.5l2.5 2.5',
  'indir':     'M12 3v12M7.5 10.5 12 15l4.5-4.5M4 20h16',
  'yukle':     'M12 21V9M7.5 13.5 12 9l4.5 4.5M4 4h16',
  'dosya':     'M7 3h7l5 5v13H7zM14 3v5h5',
  'foto':      'M3 7h4l1.5-2h7L17 7h4v13H3zM12 16.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7',
  'yenile':    'M20 12a8 8 0 1 1-2.6-5.9M20 4v5h-5',
  'cikis':     'M15 4h4v16h-4M11 8l-4 4 4 4M7 12h9',
  'kilit':     'M6 11h12v9H6zM9 11V7.5a3 3 0 0 1 6 0V11',
  'yedek':     'M4 7c0-1.7 3.6-3 8-3s8 1.3 8 3-3.6 3-8 3-8-1.3-8-3M4 7v10c0 1.7 3.6 3 8 3s8-1.3 8-3V7M4 12c0 1.7 3.6 3 8 3s8-1.3 8-3',
  'gecmis':    'M12 7v5l3.5 2M20 12a8 8 0 1 1-2.6-5.9M20 4v5h-5',
  'grafik':    'M4 20V10M10 20V4M16 20v-7M22 20H2',
  'telefon':   'M8 3l2 4-2 1.5c.9 2.2 2.4 3.7 4.5 4.5L14 11l4 2v4c0 .8-.7 1.4-1.5 1.3C9.4 17.6 4.4 12.6 3.7 5.5 3.6 4.7 4.2 4 5 4z',
  'bilgi':     'M12 11v5.5M12 7.6h.01M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18',
  'menu':      'M4 7h16M4 12h16M4 17h16',
};

interface Ozellikler extends React.SVGProps<SVGSVGElement> {
  ad: SimgeAdi;
  boyut?: number;
}

export function Simge({ ad, boyut = 18, className, ...kalan }: Ozellikler) {
  return (
    <svg
      width={boyut} height={boyut} viewBox="0 0 24 24" fill="none"
      stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true" focusable="false" {...kalan}
    >
      <path d={YOLLAR[ad]} />
    </svg>
  );
}
